import { createFileRoute } from '@tanstack/react-router';
import { TemplatesPage } from '../../../features/B5/templates-page';

export const Route = createFileRoute('/_app/settings/templates')({
  component: TemplatesPage,
});
